import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import Filter from '../../../../components/shared/icons/Filter';
import handler from '../../../../components/shared/inputHandler';
import { ContainerRadioCobranca, ButtonForm } from '../../../../components/shared/formStyles.styled';
import { getChargeData, changeFilters, getChargeDataPrint, getChargeDataPrintExcel } from '../actions';
import FilterHandler from './FilterHandler';
import { setFilter, getInitialValues } from '../charge-helpers';
import { PDFButton } from '../../../../components/Header/ButtonsHeader/DefaultButton';
import { DateContainer, FilterDateBar } from './ChargeStyles';
import {
  FilterModeRow,
  FilterControlPanel,
  ChargeFilterAndActionsRow,
  ChargeFilterPanelWrap,
  ChargeActionsWrap,
} from './ExtratoReportStyles';

const RADIO_OPTIONS = [
  { value: '1', label: 'Período' },
  { value: '0', label: 'Mês' },
];

function extratoResumo(payload) {
  if (!payload || typeof payload !== 'object') return null;
  return payload.resumo ? payload.resumo : payload;
}

const SideContent = (props) => {
  const { filtered, callback } = props;
  const resumo = extratoResumo(props.resume);
  const produtos = resumo && resumo.produtos ? resumo.produtos : {};
  const semProdutos = !produtos || Object.keys(produtos).length < 1;

  const onFilter = () => {
    setFilter(props.changedValues, props.changeFilters, props.getChargeData);
    callback();
  };

  return (
    <Fragment>
      <ChargeFilterAndActionsRow>
        <ChargeFilterPanelWrap>
          <FilterControlPanel>
            <FilterModeRow>
              <span className="filter-label">
                <Filter />
                <span style={{ marginLeft: 6 }}>Filtrar por</span>
              </span>
              <ContainerRadioCobranca className="charge-filter-radios">
                {handler({
                  size: 'field-fc field-fc-sm',
                  type: 'radio',
                  name: 'radio_filter',
                  options: RADIO_OPTIONS,
                })}
              </ContainerRadioCobranca>
            </FilterModeRow>
            <FilterDateBar>
              <DateContainer filtered={filtered} className="date-container">
                {FilterHandler(props.changedValues.radio_filter)}
              </DateContainer>
              <ButtonForm className="charge-filter-submit button-filtrar" disabled={false} onClick={onFilter}>
                FILTRAR
              </ButtonForm>
            </FilterDateBar>
          </FilterControlPanel>
        </ChargeFilterPanelWrap>

        <ChargeActionsWrap>
          <PDFButton onClick={() => props.getChargeDataPrint()} disabled={semProdutos} className="imprimir-pdf" style={{ opacity: semProdutos ? 0.35 : 1 }}>
            Imprimir/Salvar PDF
          </PDFButton>
          <PDFButton onClick={() => props.getChargeDataPrintExcel()} disabled={semProdutos} className="salvar-excel" style={{ opacity: semProdutos ? 0.35 : 1 }}>
            Salvar Excel
          </PDFButton>
        </ChargeActionsWrap>
      </ChargeFilterAndActionsRow>
    </Fragment>
  );
};

const Form = reduxForm({
  form: 'cobranca',
  enableReinitialize: true,
})(SideContent);

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getChargeData, changeFilters, getChargeDataPrint, getChargeDataPrintExcel }, dispatch);

const mapStateToProps = (state) => ({
  changedValues: state.form.cobranca !== undefined ? state.form.cobranca.values : {},
  initialValues: getInitialValues(state.chargeData.resume),
  resume: state.chargeData.resume,
  login: state.login,
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
